export default __webpack_public_path__ + "static/media/copaes.82e642db.png";